/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery, useQueryClient } from 'react-query';
import type {
    InvalidateOptions,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from 'react-query';

import { customFetchInstance } from '../../../../../../orval/client/custom-fetch';
import { useCustomMutationOptions } from '../../../../../../orval/mutator/custom-mutation-options';
import { getCustomQueryOptions } from '../../../../../../orval/mutator/custom-query-options';
import {
    PaginatedMobileValidationWorkflowListList,
    PaginatedValidationWorkflowDropdownList,
    PaginatedValidationWorkflowListList,
    ValidationWorkflowCreate,
    ValidationWorkflowRetrieve,
    ValidationWorkflowUpdate,
} from '../../models';
import type {
    ApiMobileValidationWorkflowsListParams,
    ApiValidationWorkflowsDropdownListParams,
    ApiValidationWorkflowsListParams,
    PatchedValidationWorkflowUpdateRequest,
    ValidationWorkflowCreateRequest,
    ValidationWorkflowUpdateRequest,
} from '../../models';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K,
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key !== 'queryKey') {
            Object.defineProperty(result, key, {
                enumerable: true,
                configurable: true,
                get: () => (query as Record<string, unknown>)[key],
            });
        }
    }
    return result;
};

export const getApiMobileValidationWorkflowsListUrl = (
    params?: ApiMobileValidationWorkflowsListParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/mobile/validation-workflows/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/mobile/validation-workflows/`;
};

export const apiMobileValidationWorkflowsList = async (
    params?: ApiMobileValidationWorkflowsListParams,
    options?: RequestInit,
): Promise<PaginatedMobileValidationWorkflowListList> => {
    return customFetchInstance<PaginatedMobileValidationWorkflowListList>(
        getApiMobileValidationWorkflowsListUrl(params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiMobileValidationWorkflowsListQueryKey = (
    params?: ApiMobileValidationWorkflowsListParams,
) => {
    return [
        'apiMobileValidationWorkflowsList',
        ...(params ? [params] : []),
    ] as const;
};

export const useApiMobileValidationWorkflowsListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiMobileValidationWorkflowsList>>,
    TError = unknown,
>(
    params?: ApiMobileValidationWorkflowsListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiMobileValidationWorkflowsList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getApiMobileValidationWorkflowsListQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiMobileValidationWorkflowsList>>
    > = ({ signal }) =>
        apiMobileValidationWorkflowsList(params, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiMobileValidationWorkflowsList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiMobileValidationWorkflowsListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiMobileValidationWorkflowsList>>
>;
export type ApiMobileValidationWorkflowsListQueryError = unknown;

export function useApiMobileValidationWorkflowsList<
    TData = Awaited<ReturnType<typeof apiMobileValidationWorkflowsList>>,
    TError = unknown,
>(
    params?: ApiMobileValidationWorkflowsListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiMobileValidationWorkflowsList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiMobileValidationWorkflowsListQueryOptions(
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiMobileValidationWorkflowsList = async (
    queryClient: QueryClient,
    params?: ApiMobileValidationWorkflowsListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiMobileValidationWorkflowsListQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};

export const getApiValidationWorkflowsListUrl = (
    params?: ApiValidationWorkflowsListParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/`;
};

export const apiValidationWorkflowsList = async (
    params?: ApiValidationWorkflowsListParams,
    options?: RequestInit,
): Promise<PaginatedValidationWorkflowListList> => {
    return customFetchInstance<PaginatedValidationWorkflowListList>(
        getApiValidationWorkflowsListUrl(params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiValidationWorkflowsListQueryKey = (
    params?: ApiValidationWorkflowsListParams,
) => {
    return ['apiValidationWorkflowsList', ...(params ? [params] : [])] as const;
};

export const useApiValidationWorkflowsListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiValidationWorkflowsList>>,
    TError = unknown,
>(
    params?: ApiValidationWorkflowsListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getApiValidationWorkflowsListQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiValidationWorkflowsList>>
    > = ({ signal }) =>
        apiValidationWorkflowsList(params, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiValidationWorkflowsList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiValidationWorkflowsListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiValidationWorkflowsList>>
>;
export type ApiValidationWorkflowsListQueryError = unknown;

export function useApiValidationWorkflowsList<
    TData = Awaited<ReturnType<typeof apiValidationWorkflowsList>>,
    TError = unknown,
>(
    params?: ApiValidationWorkflowsListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiValidationWorkflowsListQueryOptions(
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiValidationWorkflowsList = async (
    queryClient: QueryClient,
    params?: ApiValidationWorkflowsListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiValidationWorkflowsListQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};

export const getApiValidationWorkflowsCreateUrl = () => {
    return `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/`;
};

export const apiValidationWorkflowsCreate = async (
    validationWorkflowCreateRequest: ValidationWorkflowCreateRequest,
    options?: RequestInit,
): Promise<ValidationWorkflowCreate> => {
    return customFetchInstance<ValidationWorkflowCreate>(
        getApiValidationWorkflowsCreateUrl(),
        {
            credentials: 'same-origin',
            ...options,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
            },
            body: JSON.stringify(validationWorkflowCreateRequest),
        },
    );
};

export const useApiValidationWorkflowsCreateMutationOptions = <
    TError = unknown,
    TContext = unknown,
>(
    queryClient: QueryClient,
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsCreate>>,
            TError,
            { data: ValidationWorkflowCreateRequest },
            TContext
        >;
        skipInvalidation?: boolean;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseMutationOptions<
    Awaited<ReturnType<typeof apiValidationWorkflowsCreate>>,
    TError,
    { data: ValidationWorkflowCreateRequest },
    TContext
> => {
    const mutationKey = ['apiValidationWorkflowsCreate'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof apiValidationWorkflowsCreate>>,
        { data: ValidationWorkflowCreateRequest }
    > = props => {
        const { data } = props ?? {};

        return apiValidationWorkflowsCreate(data, requestOptions);
    };

    const onSuccess = (
        data: Awaited<ReturnType<typeof apiValidationWorkflowsCreate>>,
        variables: { data: ValidationWorkflowCreateRequest },
        context: TContext | undefined,
    ) => {
        if (!options?.skipInvalidation) {
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsListQueryKey(),
            });
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsDropdownListQueryKey(),
            });
        }
        mutationOptions?.onSuccess?.(data, variables, context);
    };

    const customOptions = useCustomMutationOptions({
        ...mutationOptions,
        mutationFn,
        onSuccess,
    });

    return customOptions;
};

export type ApiValidationWorkflowsCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof apiValidationWorkflowsCreate>>
>;
export type ApiValidationWorkflowsCreateMutationBody =
    ValidationWorkflowCreateRequest;
export type ApiValidationWorkflowsCreateMutationError = unknown;

export const useApiValidationWorkflowsCreate = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof apiValidationWorkflowsCreate>>,
        TError,
        { data: ValidationWorkflowCreateRequest },
        TContext
    >;
    skipInvalidation?: boolean;
    request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
    Awaited<ReturnType<typeof apiValidationWorkflowsCreate>>,
    TError,
    { data: ValidationWorkflowCreateRequest },
    TContext
> => {
    const backupQueryClient = useQueryClient();
    return useMutation(
        useApiValidationWorkflowsCreateMutationOptions(
            backupQueryClient,
            options,
        ),
    );
};
export const getApiValidationWorkflowsRetrieveUrl = (slug: string) => {
    return `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/${slug}/`;
};

export const apiValidationWorkflowsRetrieve = async (
    slug: string,
    options?: RequestInit,
): Promise<ValidationWorkflowRetrieve> => {
    return customFetchInstance<ValidationWorkflowRetrieve>(
        getApiValidationWorkflowsRetrieveUrl(slug),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiValidationWorkflowsRetrieveQueryKey = (slug: string) => {
    return ['apiValidationWorkflowsRetrieve', ...(slug ? [slug] : [])] as const;
};

export const useApiValidationWorkflowsRetrieveQueryOptions = <
    TData = Awaited<ReturnType<typeof apiValidationWorkflowsRetrieve>>,
    TError = unknown,
>(
    slug: string,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsRetrieve>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getApiValidationWorkflowsRetrieveQueryKey(slug);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiValidationWorkflowsRetrieve>>
    > = ({ signal }) =>
        apiValidationWorkflowsRetrieve(slug, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        enabled: slug !== null && slug !== undefined,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiValidationWorkflowsRetrieve>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiValidationWorkflowsRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiValidationWorkflowsRetrieve>>
>;
export type ApiValidationWorkflowsRetrieveQueryError = unknown;

export function useApiValidationWorkflowsRetrieve<
    TData = Awaited<ReturnType<typeof apiValidationWorkflowsRetrieve>>,
    TError = unknown,
>(
    slug: string,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsRetrieve>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiValidationWorkflowsRetrieveQueryOptions(
        slug,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiValidationWorkflowsRetrieve = async (
    queryClient: QueryClient,
    slug: string,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiValidationWorkflowsRetrieveQueryKey(slug),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};

export const getApiValidationWorkflowsUpdateUrl = (slug: string) => {
    return `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/${slug}/`;
};

export const apiValidationWorkflowsUpdate = async (
    slug: string,
    validationWorkflowUpdateRequest: ValidationWorkflowUpdateRequest,
    options?: RequestInit,
): Promise<ValidationWorkflowUpdate> => {
    return customFetchInstance<ValidationWorkflowUpdate>(
        getApiValidationWorkflowsUpdateUrl(slug),
        {
            credentials: 'same-origin',
            ...options,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
            },
            body: JSON.stringify(validationWorkflowUpdateRequest),
        },
    );
};

export const useApiValidationWorkflowsUpdateMutationOptions = <
    TError = unknown,
    TContext = unknown,
>(
    queryClient: QueryClient,
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsUpdate>>,
            TError,
            { slug: string; data: ValidationWorkflowUpdateRequest },
            TContext
        >;
        skipInvalidation?: boolean;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseMutationOptions<
    Awaited<ReturnType<typeof apiValidationWorkflowsUpdate>>,
    TError,
    { slug: string; data: ValidationWorkflowUpdateRequest },
    TContext
> => {
    const mutationKey = ['apiValidationWorkflowsUpdate'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof apiValidationWorkflowsUpdate>>,
        { slug: string; data: ValidationWorkflowUpdateRequest }
    > = props => {
        const { slug, data } = props ?? {};

        return apiValidationWorkflowsUpdate(slug, data, requestOptions);
    };

    const onSuccess = (
        data: Awaited<ReturnType<typeof apiValidationWorkflowsUpdate>>,
        variables: { slug: string; data: ValidationWorkflowUpdateRequest },
        context: TContext | undefined,
    ) => {
        if (!options?.skipInvalidation) {
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsListQueryKey(),
            });
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsDropdownListQueryKey(),
            });
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsRetrieveQueryKey(
                    variables.slug,
                ),
            });
        }
        mutationOptions?.onSuccess?.(data, variables, context);
    };

    const customOptions = useCustomMutationOptions({
        ...mutationOptions,
        mutationFn,
        onSuccess,
    });

    return customOptions;
};

export type ApiValidationWorkflowsUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof apiValidationWorkflowsUpdate>>
>;
export type ApiValidationWorkflowsUpdateMutationBody =
    ValidationWorkflowUpdateRequest;
export type ApiValidationWorkflowsUpdateMutationError = unknown;

export const useApiValidationWorkflowsUpdate = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof apiValidationWorkflowsUpdate>>,
        TError,
        { slug: string; data: ValidationWorkflowUpdateRequest },
        TContext
    >;
    skipInvalidation?: boolean;
    request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
    Awaited<ReturnType<typeof apiValidationWorkflowsUpdate>>,
    TError,
    { slug: string; data: ValidationWorkflowUpdateRequest },
    TContext
> => {
    const backupQueryClient = useQueryClient();
    return useMutation(
        useApiValidationWorkflowsUpdateMutationOptions(
            backupQueryClient,
            options,
        ),
    );
};
export const getApiValidationWorkflowsPartialUpdateUrl = (slug: string) => {
    return `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/${slug}/`;
};

export const apiValidationWorkflowsPartialUpdate = async (
    slug: string,
    patchedValidationWorkflowUpdateRequest?: PatchedValidationWorkflowUpdateRequest,
    options?: RequestInit,
): Promise<ValidationWorkflowUpdate> => {
    return customFetchInstance<ValidationWorkflowUpdate>(
        getApiValidationWorkflowsPartialUpdateUrl(slug),
        {
            credentials: 'same-origin',
            ...options,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
            },
            body: JSON.stringify(patchedValidationWorkflowUpdateRequest),
        },
    );
};

export const useApiValidationWorkflowsPartialUpdateMutationOptions = <
    TError = unknown,
    TContext = unknown,
>(
    queryClient: QueryClient,
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsPartialUpdate>>,
            TError,
            { slug: string; data?: PatchedValidationWorkflowUpdateRequest },
            TContext
        >;
        skipInvalidation?: boolean;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseMutationOptions<
    Awaited<ReturnType<typeof apiValidationWorkflowsPartialUpdate>>,
    TError,
    { slug: string; data?: PatchedValidationWorkflowUpdateRequest },
    TContext
> => {
    const mutationKey = ['apiValidationWorkflowsPartialUpdate'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof apiValidationWorkflowsPartialUpdate>>,
        { slug: string; data?: PatchedValidationWorkflowUpdateRequest }
    > = props => {
        const { slug, data } = props ?? {};

        return apiValidationWorkflowsPartialUpdate(slug, data, requestOptions);
    };

    const onSuccess = (
        data: Awaited<ReturnType<typeof apiValidationWorkflowsPartialUpdate>>,
        variables: {
            slug: string;
            data?: PatchedValidationWorkflowUpdateRequest;
        },
        context: TContext | undefined,
    ) => {
        if (!options?.skipInvalidation) {
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsListQueryKey(),
            });
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsDropdownListQueryKey(),
            });
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsRetrieveQueryKey(
                    variables.slug,
                ),
            });
        }
        mutationOptions?.onSuccess?.(data, variables, context);
    };

    const customOptions = useCustomMutationOptions({
        ...mutationOptions,
        mutationFn,
        onSuccess,
    });

    return customOptions;
};

export type ApiValidationWorkflowsPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof apiValidationWorkflowsPartialUpdate>>
>;
export type ApiValidationWorkflowsPartialUpdateMutationBody =
    | PatchedValidationWorkflowUpdateRequest
    | undefined;
export type ApiValidationWorkflowsPartialUpdateMutationError = unknown;

export const useApiValidationWorkflowsPartialUpdate = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof apiValidationWorkflowsPartialUpdate>>,
        TError,
        { slug: string; data?: PatchedValidationWorkflowUpdateRequest },
        TContext
    >;
    skipInvalidation?: boolean;
    request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
    Awaited<ReturnType<typeof apiValidationWorkflowsPartialUpdate>>,
    TError,
    { slug: string; data?: PatchedValidationWorkflowUpdateRequest },
    TContext
> => {
    const backupQueryClient = useQueryClient();
    return useMutation(
        useApiValidationWorkflowsPartialUpdateMutationOptions(
            backupQueryClient,
            options,
        ),
    );
};
export const getApiValidationWorkflowsDestroyUrl = (slug: string) => {
    return `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/${slug}/`;
};

export const apiValidationWorkflowsDestroy = async (
    slug: string,
    options?: RequestInit,
): Promise<void> => {
    return customFetchInstance<void>(
        getApiValidationWorkflowsDestroyUrl(slug),
        {
            credentials: 'same-origin',
            ...options,
            method: 'DELETE',
        },
    );
};

export const useApiValidationWorkflowsDestroyMutationOptions = <
    TError = unknown,
    TContext = unknown,
>(
    queryClient: QueryClient,
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsDestroy>>,
            TError,
            { slug: string },
            TContext
        >;
        skipInvalidation?: boolean;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseMutationOptions<
    Awaited<ReturnType<typeof apiValidationWorkflowsDestroy>>,
    TError,
    { slug: string },
    TContext
> => {
    const mutationKey = ['apiValidationWorkflowsDestroy'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof apiValidationWorkflowsDestroy>>,
        { slug: string }
    > = props => {
        const { slug } = props ?? {};

        return apiValidationWorkflowsDestroy(slug, requestOptions);
    };

    const onSuccess = (
        data: Awaited<ReturnType<typeof apiValidationWorkflowsDestroy>>,
        variables: { slug: string },
        context: TContext | undefined,
    ) => {
        if (!options?.skipInvalidation) {
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsListQueryKey(),
            });
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsDropdownListQueryKey(),
            });
            queryClient.invalidateQueries({
                queryKey: getApiValidationWorkflowsRetrieveQueryKey(
                    variables.slug,
                ),
            });
        }
        mutationOptions?.onSuccess?.(data, variables, context);
    };

    const customOptions = useCustomMutationOptions({
        ...mutationOptions,
        mutationFn,
        onSuccess,
    });

    return customOptions;
};

export type ApiValidationWorkflowsDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof apiValidationWorkflowsDestroy>>
>;

export type ApiValidationWorkflowsDestroyMutationError = unknown;

export const useApiValidationWorkflowsDestroy = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof apiValidationWorkflowsDestroy>>,
        TError,
        { slug: string },
        TContext
    >;
    skipInvalidation?: boolean;
    request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
    Awaited<ReturnType<typeof apiValidationWorkflowsDestroy>>,
    TError,
    { slug: string },
    TContext
> => {
    const backupQueryClient = useQueryClient();
    return useMutation(
        useApiValidationWorkflowsDestroyMutationOptions(
            backupQueryClient,
            options,
        ),
    );
};
export const getApiValidationWorkflowsDropdownListUrl = (
    params?: ApiValidationWorkflowsDropdownListParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/dropdown/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/validation-workflows/dropdown/`;
};

export const apiValidationWorkflowsDropdownList = async (
    params?: ApiValidationWorkflowsDropdownListParams,
    options?: RequestInit,
): Promise<PaginatedValidationWorkflowDropdownList> => {
    return customFetchInstance<PaginatedValidationWorkflowDropdownList>(
        getApiValidationWorkflowsDropdownListUrl(params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiValidationWorkflowsDropdownListQueryKey = (
    params?: ApiValidationWorkflowsDropdownListParams,
) => {
    return [
        'apiValidationWorkflowsDropdownList',
        ...(params ? [params] : []),
    ] as const;
};

export const useApiValidationWorkflowsDropdownListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiValidationWorkflowsDropdownList>>,
    TError = unknown,
>(
    params?: ApiValidationWorkflowsDropdownListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsDropdownList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getApiValidationWorkflowsDropdownListQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiValidationWorkflowsDropdownList>>
    > = ({ signal }) =>
        apiValidationWorkflowsDropdownList(params, {
            signal,
            ...requestOptions,
        });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiValidationWorkflowsDropdownList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiValidationWorkflowsDropdownListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiValidationWorkflowsDropdownList>>
>;
export type ApiValidationWorkflowsDropdownListQueryError = unknown;

export function useApiValidationWorkflowsDropdownList<
    TData = Awaited<ReturnType<typeof apiValidationWorkflowsDropdownList>>,
    TError = unknown,
>(
    params?: ApiValidationWorkflowsDropdownListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiValidationWorkflowsDropdownList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiValidationWorkflowsDropdownListQueryOptions(
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiValidationWorkflowsDropdownList = async (
    queryClient: QueryClient,
    params?: ApiValidationWorkflowsDropdownListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiValidationWorkflowsDropdownListQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};
